module.exports = __webpack_public_path__ + "img/iq.7c61deff.svg";